import { createApi } from '@redux/createApi';

export const misuseApi = createApi({
  reducerPath: 'misuseApi',
  tagTypes: ['MisuseLimit', 'MisuseCommission', 'MisuseReport'],
  endpoints: (builder) => ({
    getMisuseReport: builder.query({
      query: ({ start, end } = {}) => {
        const toISODate = (d) =>
          `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
        const params = {};
        if (start) {
          params.start_date = toISODate(start);
        }
        if (end) {
          params.end_date = toISODate(end);
        }
        return { url: '/admin/misuse/report', method: 'get', params };
      },
      providesTags: ['MisuseReport'],
    }),
    getMisuseLimit: builder.query({
      query: () => ({ url: '/admin/misuse/limit', method: 'get' }),
      providesTags: ['MisuseLimit'],
    }),
    setMisuseLimit: builder.mutation({
      query: ({ limit_amount }) => ({
        url: '/admin/misuse/limit',
        method: 'post',
        params: { limit_amount },
      }),
      invalidatesTags: ['MisuseLimit'],
    }),
    getMisuseCommissionRate: builder.query({
      query: () => ({ url: '/admin/misuse/commission-rate', method: 'get' }),
      providesTags: ['MisuseCommission'],
    }),
    setMisuseCommissionRate: builder.mutation({
      query: ({ commission_rate }) => ({
        url: '/admin/misuse/commission-rate',
        method: 'post',
        params: { commission_rate },
      }),
      invalidatesTags: ['MisuseCommission'],
    }),
  }),
});

export const {
  useGetMisuseReportQuery,
  useGetMisuseLimitQuery,
  useSetMisuseLimitMutation,
  useGetMisuseCommissionRateQuery,
  useSetMisuseCommissionRateMutation,
} = misuseApi;
